const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const normalizeEmail = (value) => String(value || "").trim().toLowerCase();

export const normalizeMarketingRecipients = (values = []) => {
  const unique = new Set();
  (Array.isArray(values) ? values : []).forEach((value) => {
    const email = normalizeEmail(value);
    if (EMAIL_REGEX.test(email)) unique.add(email);
  });
  return Array.from(unique);
};

export const buildCrmEmailContacts = (deals = []) => {
  const seen = new Set();
  const contacts = [];
  (Array.isArray(deals) ? deals : []).forEach((deal) => {
    const email = normalizeEmail(deal?.email);
    if (!EMAIL_REGEX.test(email) || seen.has(email)) return;
    seen.add(email);
    contacts.push({
      id: deal?.id || email,
      email,
      name: String(deal?.name || "").trim(),
      company: String(deal?.company || "").trim(),
      segment: String(deal?.segment || "").trim(),
      owner: String(deal?.owner || "").trim(),
    });
  });
  return contacts.sort((a, b) =>
    (a.company || a.email).localeCompare(b.company || b.email, "pt-BR"),
  );
};
